import { z } from "zod"

import { HeaderValue, rowSchema, RowValue } from "./schema"
import { isArray } from "~/src/lib/any"
import { validate, ValidationError } from "~/src/lib/object"

export type { ValidationError }

export class Validations {
  columns: HeaderValue["columns"]
  schema: z.ZodSchema

  constructor(columns: HeaderValue["columns"], formats: HeaderValue["formats"]) {
    this.columns = columns
    this.schema = rowSchema(columns, formats)
  }

  validateRow(row: RowValue): Record<HeaderValue["columns"][number]["key"], Array<ValidationError>> | null {
    const testRow: Record<string, unknown> = {}
    this.columns.map((column) => (testRow[column.key] = row[column.key]))

    const errorList = validate(this.schema, testRow)
    if (errorList.length === 0) {
      return null
    }

    const invalidRow: Record<string, Array<ValidationError>> = {}

    errorList.forEach((error: ValidationError) => {
      if (error.path) {
        // The path is JSON stringified (e.g., '["fieldName"]' or '["nested","field"]')
        // Parse it to get the actual field path
        const parsedPath = JSON.parse(error.path) as Array<string | number>
        const cleanPath = String(parsedPath[0])

        if (isArray(invalidRow[cleanPath])) {
          invalidRow[cleanPath].push(error)
        } else {
          invalidRow[cleanPath] = [error]
        }
      }
    })

    return invalidRow
  }
}
